import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

export const DragAndDrop = ({ children, onDrop, type, takeFirst, className, ...props }) => {
    const [isDragOverStarted, toggleDragOver] = useState(false);
    const [counter, setCount] = useState(0);

    const ACCEPT_TYPES = ['image/png', 'image/jpeg', 'image/jpg'];

    const onDragEnter = e => {
        let count = counter + 1;
        e.preventDefault();
        e.stopPropagation();
        toggleDragOver(count > 0);
        setCount(count);
    };
    const onDragLeave = e => {
        let count = counter - 1;
        toggleDragOver(count > 0);
        setCount(count);
    };
    const onFileDrop = e => {
        e.preventDefault();
        setCount(0);
        toggleDragOver(false);
        onDrop(e.dataTransfer.files);
    };
    const onDragOver = e => {
        e.preventDefault();
        e.stopPropagation();
    };
    return (
        <div
            className={classNames(styles.dropWrapper, className)}
            onDrop={onFileDrop}
            onDragOver={onDragOver}
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
            {...props}
        >
            {isDragOverStarted && (
                <div className={classNames(styles.dropContaner)}>
                    <div className={styles.block}>
                        <p className={classNames(styles.textImport)}>Drag and drop your file here</p>
                    </div>
                </div>
            )}
            {children}
        </div>
    );
};

export default DragAndDrop;
